// extracted by mini-css-extract-plugin
module.exports = {"pricing-type-badge":"PricingTypeBadge_pricing-type-badge__3_bs4"};